import { BoxProps } from '@mui/material';

export type TSlide = {
  isVideo: boolean;
  slideSrc: string;
  previewSrc: string;
  slideDuration: number;
};

export enum ECarouselVariant {
  Default = 'default',
  Compact = 'compact',
  Extended = 'extended',
  Fullscreen = 'fullscreen',
}

export type TCarouselProps = Omit<BoxProps, 'content'> & {
  urls: (string | Blob)[];
  mainImageUrl?: string;
  variant?: ECarouselVariant;
  autoplay?: boolean;
  withFullscreen?: boolean;
  thumbnailsButtons?: boolean;
  isPreview: boolean;
  onFullScreenClick?: () => void;
  fullscreenOnImageClick?: boolean;
  onSendAnalyticsEvent?: () => void;
  height?: {
    xs?: string;
    sm?: string;
    md?: string;
    lg?: string;
  };
  maxHeight?: number;
  hasBlobs?: boolean;
};

export type TSetupCarouselStore = Pick<TCarouselProps, 'urls' | 'variant'>;

export type TCarouselStore = Omit<TCarouselProps, 'urls'> & {
  currentIndex: number;
  currentSlide: TSlide;
  slides: TSlide[];
  isHovered: boolean;
  lastInteractionTimestamp: number;
  actions: {
    setIsHovered: (hovered: boolean) => void;
    updateLastInteraction: () => void;
    goToNextSlide: () => void;
    goToPrevSlide: () => void;
    goToSlide: (index: number) => void;
    setupStore: (props: TSetupCarouselStore) => Promise<void>;
  };
};
